import App from './App.vue';
import i18n from './i18n';
import { piniaPluginErrorNotifier, piniaPluginLoadingState } from './plugins';
import { hashString } from '@/@core/utils';
import { updateHtmlLangPlugin } from '@/plugins/updateHtmlLangPlugin';
import { useNotificationStore } from '@/stores/useNotificationStore';
import { useUserStore } from '@/stores/userStore';
import AADesignSystem from '@aleph-alpha/ds-components-vue';
import '@unocss/reset/tailwind.css';
import 'katex/dist/katex.min.css';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import 'virtual:uno.css';
import { createApp } from 'vue';

const pinia = createPinia();

export const app = createApp(App);

app.use(i18n);

// @ts-expect-error AADesignSystem is a plugin, but it's not typed as such in the package.
app.use(AADesignSystem);

pinia.use(
  createPersistedState({
    key: (id) => {
      const userStore = useUserStore();
      const prefix = userStore.userId
        ? userStore.userId
        : hashString('assistantuicache', true);
      return `${prefix}-${id}`;
    },
  }),
);
pinia.use(piniaPluginLoadingState);
pinia.use(piniaPluginErrorNotifier(useNotificationStore, i18n.global));
app.use(pinia);
app.use(updateHtmlLangPlugin);

app.mount('#app');
